import {css} from 'styled-components';

import type {StyledProps} from './types';

import {getColor} from '../../styles/utils';
import {platform} from '../../utils/platform';

const imageTransition = css<StyledProps>`
  transition: ${p => (p.animated ? 'opacity 0.5s' : 'initial')};
`;

export const image = css<StyledProps>`
  position: relative;
  width: 100%;
  height: 100%;
  ${imageTransition};
  ${p => css`
    opacity: ${p.isLoaded ? 1 : 0};
  `};
`;

export const blurImage = css<StyledProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  ${imageTransition};
  filter: blur(${p => p.blurFactor || 20}px);
  ${p =>
    platform.isWeb &&
    css`
      opacity: ${p.isLoaded ? 1 : 0};
    `}
`;

export const placeholder = css<StyledProps>`
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  display: flex;
  transition: ${p => (p.animated ? 'opacity 0.3s' : 'initial')};
`;

export const alt = css`
  text-align: center;
  color: ${getColor('text3')};
  font-family: ${p => (platform.isNative ? p.theme.font.regular : 'inherit')};
`;

const base = css<StyledProps>`
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const web = css<StyledProps>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  ${base}
`;

export const native = css<StyledProps>`
  ${base}
`;
